/**
 * Utility function to format user role codes into display names
 * Centralizes role name mapping to avoid duplication across components
 */

export const formatRoleName = (role) => {
  const roleNames = {
    'central_help_desk': 'Central Help Desk',
    'admin': 'Admin',
    'superadmin': 'Super Admin',
    'manager': 'Manager',
    'technician': 'Technician',
    'coordinator': 'Coordinator',
    'custodian': 'Custodian'
  };

  return roleNames[role] || role.charAt(0).toUpperCase() + role.slice(1).replace(/_/g, ' ');
};
